import { render, staticRenderFns } from "./v-sidebar-item.vue?vue&type=template&id=6fa25f67&scoped=true&"
import script from "./v-sidebar-item.vue?vue&type=script&lang=js&"
export * from "./v-sidebar-item.vue?vue&type=script&lang=js&"
import style0 from "./v-sidebar-item.vue?vue&type=style&index=0&id=6fa25f67&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa25f67",
  null
  
)

export default component.exports